module.exports = __webpack_public_path__ + "img/yzcgBg.8d135f84.png";